import { render, staticRenderFns } from "./IconConnect.vue?vue&type=template&id=a2f46d8e"
import script from "./IconConnect.vue?vue&type=script&lang=ts"
export * from "./IconConnect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports